import { SVGProps } from 'react';

export const IconCross = ({
  strokeWidth = 2,
  variant,
  ...props
}: SVGProps<SVGSVGElement> & { variant?: 's' | 'm' }) => {
  if (variant === 's')
    return (
      <svg viewBox='0 0 20 20' {...props}>
        <path d='M6 6L14 14' stroke='currentColor' strokeWidth={strokeWidth} strokeLinecap='round' />
        <path d='M6 14L14 6' stroke='currentColor' strokeWidth={strokeWidth} strokeLinecap='round' />
      </svg>
    );

  return (
    <svg viewBox='0 0 24 24' {...props}>
      <path d='M6 6L18 18' stroke='currentColor' strokeWidth={strokeWidth} strokeLinecap='round' />
      <path d='M6 18L18 6' stroke='currentColor' strokeWidth={strokeWidth} strokeLinecap='round' />
    </svg>
  );
};
